interface Threshold {
	id: string;
	min?: number;
	max?: number;
	feedbackID: string;
	fromSubmission: number;
}

const simplifiedThresholds: Threshold[] = [
	//messaggi gravi
	{ id: 'price', min: 2, max: 3.5, feedbackID: 'MSG1', fromSubmission: 1 },
	{
		id: 'daysReceivable',
		min: 15,
		max: 60,
		feedbackID: 'MSG1',
		fromSubmission: 1
	},
	{
		id: 'marketingExpenses',
		min: 0,
		max: 15000000,
		feedbackID: 'MSG1',
		fromSubmission: 1
	},
	// {
	// 	id: 'soldUnits',
	// 	min: 0,
	// 	max: 60000000,
	// 	feedbackID: 'MSG1',
	// 	fromSubmission: 1
	// },
	{
		id: 'quality',
		min: 1,
		feedbackID: 'MSG1',
		fromSubmission: 1
	},
	{ id: 'neededJuice', min: 0, feedbackID: 'MSG2', fromSubmission: 1 },
	{
		id: 'endingWhJuiceOnProducedUnits',
		min: 0.05,
		feedbackID: 'MSG3',
		fromSubmission: 1
	},
	{
		id: 'shortTermDebtsOnRevenues',
		max: 0.2,
		feedbackID: 'MSG4',
		fromSubmission: 2
	},
	/*{ id: 'leverage', min: 0.25, feedbackID: 'MSG4', fromSubmission: 2 },*/
	{ id: 'operatingIncome', min: 0, feedbackID: 'MSG6', fromSubmission: 1 },
	{ id: 'netIncome', min: 0, feedbackID: 'MSG7', fromSubmission: 1 },

	//messaggi meno gravi
	{
		id: 'buildingsSaturation',
		min: 1,
		max: 2,
		feedbackID: 'MSG8',
		fromSubmission: 2
	},
	{
		id: 'marketingExpenses',
		min: 5000000,
		feedbackID: 'MSG11',
		fromSubmission: 2
	},
	{
		id: 'marketingExpenses',
		max: 12000000,
		feedbackID: 'MSG12',
		fromSubmission: 2
	},
	{
		id: 'endingWhApplesOnPurchasedUnits',
		max: 0.15,
		feedbackID: 'MSG13',
		fromSubmission: 2
	},
	{
		id: 'endingWhBottlesOnPurchasedUnits',
		max: 0.07,
		feedbackID: 'MSG13',
		fromSubmission: 2
	},
	{
		id: 'endingWhJuiceOnPurchasedUnits',
		max: 0.1,
		feedbackID: 'MSG14',
		fromSubmission: 2
	},
	{ id: 'roi', min: 0.05, feedbackID: 'MSG15', fromSubmission: 2 },
	{ id: 'ros', min: 0.05, feedbackID: 'MSG16', fromSubmission: 2 },
	{ id: 'roe', min: 0.04, feedbackID: 'MSG17', fromSubmission: 2 },
	{ id: 'cash', max: 23000000, feedbackID: 'MSG18', fromSubmission: 2 }
];
let thresholdsPerYear: Threshold[] = [
	{ id: 'quality:2', min: 2, feedbackID: 'MSG9', fromSubmission: 2 },
	{ id: 'quality:3', min: 2, feedbackID: 'MSG9', fromSubmission: 2 },
	{ id: 'quality:2', max: 4, feedbackID: 'MSG10', fromSubmission: 2	},
	{ id: 'quality:3', max: 4, feedbackID: 'MSG10', fromSubmission: 2 }
];
simplifiedThresholds.forEach(ele => {
	for (let i = 1; i <= 3; i++) {
		thresholdsPerYear.push({
			...ele,
			id: `${ele.id}:${i}`
		});
	}
});

// sender keys:
// 1: CEO
// 2: Dir. Marketing e Vendite
// 3: CFO
// 4: Dir. Produzione

const messages = [
	{
		id: 'MSG1',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'I am not happy with your plan',
		from: 1,
		text:
			'Your plan is not consistent with the basic assumptions about my company and my new venture. Review the background and briefing information and submit a more reasonable plan next time!'
	},
	{
		id: 'MSG2',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'Problems with your production plan',
		from: 2,
		text:
			'Your production plan is not consistent with the expected sales of the period!'
	},
	{
		id: 'MSG3',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'Problems with your production plan',
		from: 2,
		text:
			'Your production plan does not meet our requirements. Revise and re-submit! '
	},
	{
		id: 'MSG4',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'Short-term debt is too high!',
		from: 3,
		text:
			'The amount of short-term debt assumed in your plan is simply unaffordable: it is too risky for our company!'
	},
	{
		id: 'MSG5',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'Net working capital issues',
		from: 3,
		text:
			'The net working capital implied in your plan is too high. Revise your plan!'
	},
	{
		id: 'MSG6',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'I cannot accept a negative ebit!',
		from: 1,
		text:
			'Submitting a plan with a negative Opeating Profit means you are wasting my time. Revise your assumptions!'
	},
	{
		id: 'MSG7',
		isRead: false,
		hits: 1,
		cost: 5000,
		subject: 'You are wasting my time',
		from: 1,
		text:
			'Submitting a plan with a negative Net Income means you are wasting my time. Revise your assumptions!'
	},

	{
		id: 'MSG8',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Insufficient production lines saturation',
		from: 3,
		text:
			'Buildings are not fully saturated with production lines. Revise your plan and try to optimize the return on production facilities.'
	},
	{
		id: 'MSG9',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Check the quality of our products',
		from: 2,
		text:
			'The quality of our products may be too poor for the success of this new business venture. '
	},
	{
		id: 'MSG10',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Quality costs are too high!',
		from: 3,
		text: 'You are investing a lot in quality! Are you sure it is worth it?'
	},
	{
		id: 'MSG11',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Insufficient marketing',
		from: 2,
		text:
			'Levereging on a solid marketing plan is one of the main keys of the success of this venture Are you sure the expenses predicted in the plan will be enough to effectively commercialize this new product?'
	},
	{
		id: 'MSG12',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Marketing costs are too high!',
		from: 3,
		text:
			'Marketing expenses surely are important. Nonetheless, think about the effect on profits and cash flows!'
	},
	{
		id: 'MSG13',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Raw materials inventory issues',
		from: 3,
		text:
			"I think that raw materials inventory is too high. Don't waste the company monetary resources!"
	},
	{
		id: 'MSG14',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Finished goods inventory issues',
		from: 3,
		text:
			"I think that finished goods inventory is too high. Don't waste the company monetary resources!"
	},
	{
		id: 'MSG15',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Check your ROI',
		from: 3,
		text: 'Return on Investment is not enough for the success of the plan'
	},
	{
		id: 'MSG16',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Check your ROS',
		from: 2,
		text: 'Return on Sales is quite low! You should revise your assumptions'
	},
	{
		id: 'MSG17',
		isRead: false,
		hits: 0,
		cost: 1000,
		subject: 'Check your ROE',
		from: 1,
		text:
			'Return on Equity may disappoint our shareholders. I am sure you can do better…'
	},
	{
		id: 'MSG18',
		isRead: false,
		hits: 0,
		cost: -5000,
		subject: 'Good work!',
		from: 1,
		text:
			'I see that you are generating a lot of cash! Great…any dividend for me?'
	},
	{
		id: 'MSG19',
		isRead: false,
		hits: 0,
		cost: 0,
		subject: 'Good results',
		from: 1,
		text: 'Your proposal is ok but I am sure you can finetune it and improve your performance in the next round. I have high expectations of your consulting team!'
	},
];

export default {
	thresholds: thresholdsPerYear,
	messages: messages.map(message => ({...message, send: false}))
};
